<template>
  <div class="products-page p-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="page-title mb-0">Products Management</h4>
      <button class="btn btn-add" @click="showAddDialog = true">
        <i class="bi bi-plus-lg me-1"></i> Add New Product
      </button>
    </div>

    <AddProductDialog v-if="showAddDialog" @close="showAddDialog = false" @saved="handleSaved" />
    <UpdateProductDialog v-if="showUpdateDialog" :productData="selectedProduct" @close="showUpdateDialog = false" @saved="handleSaved"/>

    <div v-if="loading" class="text-center py-5 text-muted">
      <div class="spinner-border text-warning" role="status"></div>
      <p class="mt-2">Loading products...</p>
    </div>

    <div v-else>
      <table class="table table-hover align-middle shadow-sm rounded">
        <thead class="table-gold">
          <tr>
            <th style="width: 60px;">ID</th>
            <th>Name</th>
            <th style="width: 120px;">Price</th>
            <th style="width: 160px;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in products" :key="p.id">
            <td>{{ p.id }}</td>
            <td>
              <input v-model="p.name" class="form-control form-control-sm border-0 bg-light" />
            </td>
            <td>
              <input v-model.number="p.price" type="number" step="0.01" class="form-control form-control-sm border-0 bg-light" />
            </td>
            <td class="text-center">
              <button class="btn btn-outline-primary btn-sm me-2" title="Edit" @click="openUpdateDialog(p)">
                <i class="bi bi-pencil-square"></i>
              </button>

              <button class="btn btn-outline-danger btn-sm" title="Delete" @click="remove(p.id)">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!products.length" class="text-center text-muted py-4">
        <i class="bi bi-box-seam fs-4 d-block mb-2"></i>
        No products found.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddProductDialog from "@/components/admin/AddProductDialog.vue";
import UpdateProductDialog from "@/components/admin/UpdateProductDialog.vue";
import { useToast } from "vue-toastification";

export default {
  components: { AddProductDialog, UpdateProductDialog },
  data() {
    return {
      showAddDialog: false,
      showUpdateDialog: false,
      selectedProduct: null,
    };
  },
  computed: {
    ...mapGetters("productsAdmin", ["allProducts", "isLoading"]),
    products() {
      return this.allProducts;
    },
    loading() {
      return this.isLoading;
    },
  },
  methods: {
    ...mapActions("productsAdmin", [
      "fetchProducts",
      "updateProduct",
      "deleteProduct",
    ]),

    async handleSaved() {
      const toast = useToast();
      try {
        this.showAddDialog = false;
        this.showUpdateDialog = false;
        await this.fetchProducts();
        toast.success("✅ Ürün başarıyla kaydedildi!");
      } catch (error) {
        console.error(error);
        toast.error("❌ Ürün kaydetme sırasında hata oluştu, Lütfen tekrar dene!");
      }
    },

    async remove(id) {
      const toast = useToast();
      if (confirm("Bu ürünü silmek istediğine emin misin?")) {
        try {
          await this.deleteProduct(id);
          await this.fetchProducts();
          toast.success("🗑️ Ürün başarıyla silindi!");
        } catch (error) {
          console.error(error);
          toast.error("❌ Ürün silinemedi!");
        }
      }
    },

    openUpdateDialog(product) {
      this.selectedProduct = product;
      this.showUpdateDialog = true;
    },
  },
  mounted() {
    this.fetchProducts();
  },
};
</script>

<style scoped>
.products-page {
  font-family: "Poppins", sans-serif;
  color: #333;
}

.page-title {
  color: #c89d43;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-add {
  background-color: #c89d43;
  color: #fff;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  transition: all 0.3s ease;
}

.btn-add:hover {
  background-color: #b0842d;
  transform: translateY(-1px);
}

.table {
  border-radius: 10px;
  overflow: hidden;
}

.table-gold {
  background-color: #f8f5ef;
  color: #6b4f20;
  font-weight: 600;
  border-bottom: 2px solid #c89d43;
}

.btn-update {
  background-color: #f2e3c6;
  color: #6b4f20;
  border: none;
  transition: all 0.3s ease;
}

.btn-update:hover {
  background-color: #e4c885;
}

.btn-delete {
  background-color: #fbe4e4;
  color: #d9534f;
  border: none;
  transition: all 0.3s ease;
}

.btn-delete:hover {
  background-color: #f8c9c9;
}

.btn-outline-primary, .btn-outline-danger {
  width: 34px;
  height: 34px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 6px;
}

.btn-outline-primary, .btn-outline-danger {
  width: 34px;
  height: 34px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 6px;
}

.btn-outline-primary:hover {
  background-color: #0d6efd;
  color: white;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  color: white;
}
</style>
